import Vue from 'vue'

/**
 * @author José Luis R <jose.luis@jbge.com>
 * @param id package's id
 */

const fetchePackageZip = id =>
  Vue.$http.get(`extranet/package/zip/${id}/`)
    .then(response => response.data)
    .catch((error) => { throw error })

export default fetchePackageZip


// WEBPACK FOOTER //
// ./src/services/extranet/fetchePackageZip.js